import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HeroSection from "@/components/sections/HeroSection";

// Lazy-load below-the-fold sections
const WhySection = lazy(() => import("@/components/sections/WhySection"));
const WhatIsSection = lazy(() => import("@/components/sections/WhatIsSection"));
const BenefitsSection = lazy(() => import("@/components/sections/BenefitsSection"));
const UseCasesSection = lazy(() => import("@/components/sections/UseCasesSection"));
const ResourcesSection = lazy(() => import("@/components/sections/ResourcesSection"));
const BlogSection = lazy(() => import("@/components/sections/BlogSection"));
const NewsletterSection = lazy(() => import("@/components/sections/NewsletterSection"));
const FAQSection = lazy(() => import("@/components/sections/FAQSection"));
const FinalCTASection = lazy(() => import("@/components/sections/FinalCTASection"));

const Index = () => (
  <div className="min-h-screen bg-background">
    <Navbar />
    <main id="main-content">
      <HeroSection />
      <Suspense fallback={<div className="min-h-[50vh]" />}>
        <WhySection />
        <WhatIsSection />
        <BenefitsSection />
        <UseCasesSection />
        <ResourcesSection />
        <BlogSection />
        <NewsletterSection />
        <FAQSection />
        <FinalCTASection />
      </Suspense>
    </main>
    <Footer />
  </div>
);

export default Index;
